<template>
  <div id="report">
    <div v-if="Object.keys(getTransactions).length" data-type="list">
      <div v-for="(transactionArray, dateKey) in getTransactions" :key="dateKey">
        <div class="report-date-container">
          <span>{{ formatRelativeDate(dateKey) }}</span>
        </div>
        <ul class="list">
          <TransactionItem
            v-for="(transaction, index) in transactionArray"
            ref="TransactionItem"
            :key="`${transaction.owner_id}_${transaction.created_at}_${index}`"
            :transaction="transaction"
          />
        </ul>
      </div>
    </div>
    <img
      v-else-if="TRANSACTIONS.loading"
      src="@/assets/img/loader.svg"
    />
    <div v-else class="empty-list">
      <p>{{ $t('no.operations') }}</p>
      <video :poster="require(`@/assets/img/${getIntroVideo.poster}.png`)" controls>
        <source :src="`https://docs.capusta.space/video/${getIntroVideo.video}.mp4`" type="video/mp4">
        Your browser does not support the video tag.
      </video>
    </div>
    <transition name="fade">
      <TransactionsSlider
        v-if="!isDeviceSize.desktop && SELECTED_TRANSACTION.owner_id"
        v-preventWindowScrolling
      />
    </transition>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import moment from 'lib/utils/date';

import TransactionItem from '@/components/main/TransactionItem';
import TransactionsSlider from '@/components/otherElements/TransactionsSlider';

export default {
  name: 'Report',
  components: {
    TransactionItem,
    TransactionsSlider,
  },
  computed: {
    getIntroVideo() {
      const video = this.isStreamerProject
        ? 'intro4streamers' : 'Capusta_Intro';

      const poster = this.isStreamerProject
        ? 'intro-video-streamers-poster' : 'intro-video-payments-poster';

      return { video, poster };
    },
    ...mapState([
      'TRANSACTIONS',
      'SELECTED_TRANSACTION',
    ]),
    ...mapGetters([
      'getTransactions',
      'isDeviceSize',
      'isStreamerProject',
    ]),
  },
  methods: {
    formatRelativeDate(date) {
      const isYesterday = moment().diff(moment(date, 'DD.MM.YYYY'), 'day') === 1;
      const isToday = moment().diff(moment(date, 'DD.MM.YYYY'), 'day') === 0;
      const isTomorrow = moment().diff(moment(date, 'DD.MM.YYYY'), 'day') === -1;

      if (isYesterday) {
        return this.$t('common.yesterday');
      }

      if (isToday) {
        return this.$t('common.today');
      }

      if (isTomorrow) {
        return this.$t('common.tomorrow');
      }

      return date;
    },
  },
};
</script>

<style lang="sass">
  .empty-list
    font-weight: 500
    font-size: 14px
    line-height: 20px
    color: #fff

    p
      margin: 0 0 10px
      padding: 0 20px
      line-height: 40px
      opacity: .25

    video
      width: 100%

      +respond-to('medium')
        border-radius: 5px

  .report-date-container
    line-height: 40px
    padding: 0 20px

    +respond-to('small')
      padding: 0

  #report
    width: 100%
    margin-top: 10px

    +respond-to("medium")
      flex-basis: 57%
      max-width: 57%

    > div > div
      margin-bottom: 1rem
      padding: 0
      text-align: left

      #{theme("eclipse")} &
        color: #C0C0C0

      #{theme("obsidian")} &
        color: #565663

    ul
      +respond-to("medium")
        padding: 0

      .description
        overflow: hidden
        margin-top: 0.64rem
        padding: 0.64rem
        color: #212121
        border-radius: 0.36rem
        background-color: #CCC

        div
          padding: 0.64rem

          &:first-child
            background-color: #58B4B4

        a
          color: #9B51E0
</style>
